import React, { useState , useEffect, useContext} from 'react';

import { useNavigate } from 'react-router-dom'
import { ShareContext } from '../context/sharecontext';
import * as Constants from '../Constants';
import LoadingImg from '../images/loading.gif';

import IdLayout from '../components/_layout';
import IdInput from '../components/idInput';
import IdSelect from '../components/idSelect';

function Companies() {
    const navigate = useNavigate();
    const { profile, token } = useContext(ShareContext);
    const [companies, setCompanies] =useState([]);
    const [fcompanies, setFCompanies] =useState([]);
    const [plans, setPlans] =useState([]);
    const [loading, setLoading] =useState(false);
    const [view, setView] = useState('list');
    const [err, setErr] = useState('');
    const [search, setSearch] = useState('');
    const [company, setCompany] = useState({});
    const [newCompany, setNewCompany] = useState({});
    const [showStatus,setShowStatus] = useState(false);
    const [successInfo, setSuccessInfo] = useState(null);
    const [newUser, setNewUser] = useState({});
    const [userErr, setUserErr] = useState('');
    const [userSuccessInfo, setUserSuccessInfo] = useState(null);

    const roleOptions=[{value:'Agent',text:'Agent'},{value:'Com-Owner',text:'Com-Owner (company admin)'}];

    useEffect(() => {
        Load();
    }, []);

    const getPlanName=(planId)=>{
        var p=plans?.find(d=>d.id==planId);
        return p?p.name:'';
    }

    const Load=async()=>{
        var urls=`${Constants.rooturl}/customer/companies`;
        try {
            setLoading(true);
            const resp = await fetch(urls, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
              },
            });

            const data = await resp.json();

            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setCompanies(data.coms);
                setFCompanies(data.coms);
                setPlans(data.plans);
            }else if(data.code===-10){
                navigate('/login');
            }else {
                setErr(data.status);
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
          }
     }

    const onSearch=(value)=>{
        setSearch(value);
        if(value!=''){
            const filtered = companies?.filter(item => {
                return item.name?.toLowerCase().includes(value.toLowerCase())
                    || item.email?.toLowerCase().includes(value.toLowerCase())
                    || item.adminEmail?.toLowerCase().includes(value.toLowerCase())
            })
            setFCompanies(filtered);
        }else{
            setFCompanies(companies);
        }
    }

    const onNewCompany=()=>{
        setNewCompany({currentPlanId: plans?.length>0?plans[0].id:1});
        setErr('');
        setSuccessInfo(null);
        setView('new');
    }

    const onCancel=()=>{
        setView('list');
        setErr('');
        setUserErr('');
    }

    const onAddUser=(c)=>{
        setCompany(c);
        setNewUser({companyId:c.id, userType:'Agent', unitBalance:0});
        setUserErr('');
        setUserSuccessInfo(null);
        setView('adduser');
    }

    const onSaveUser=async(e)=>{
        e.preventDefault();
        setLoading(true);
        setUserErr('');
        try {
            var v={...newUser, status:'active'};
            const resp = await fetch(`${Constants.rooturl}/customer`, {
              method: 'POST',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
              },
            });

            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setUserSuccessInfo({name:`${newUser.firstname} ${newUser.lastname||''}`, email:newUser.email, password:data.tempPassword, companyName:company.name});
                setView('list');
            }else if(data.code===-10){
                navigate('/login');
            }else {
                setUserErr(data.status || 'Could not add this user.');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setUserErr(Constants.serverErr);
          }
    }

    const onSaveCompany=async(e)=>{
        e.preventDefault();
        setLoading(true);
        setErr('');
        try {
            var v={...newCompany};
            const resp = await fetch(`${Constants.rooturl}/customer/companies`, {
              method: 'POST',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
              },
            });

            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                setSuccessInfo({name:newCompany.name, email:data.adminEmail, password:data.tempPassword});
                Load();
                setView('list');
            }else if(data.code===-10){
                navigate('/login');
            }else {
                setErr(data.status || 'Could not create the company. Please check the details and try again.');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
          }
    }

    const onToggleStatus=(c)=>{
        setCompany(c);
        setShowStatus(true);
    }

    const resetStatus=()=>{
        setShowStatus(false);
    }

    const onChangeStatus=async()=>{
        setLoading(true);
        try {
            var v={...company, status: company.status=='enable'?'disable':'enable'};
            const resp = await fetch(`${Constants.rooturl}/customer/companies/${company.id}`, {
              method: 'PUT',
              body:JSON.stringify(v) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': token,
              },
            });

            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
                Load();
                setShowStatus(false);
            }else if(data.code===-10){
                navigate('/login');
            }else {
                setErr(data.status || 'Could not update the company status.');
                setShowStatus(false);
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
            setShowStatus(false);
          }
    }

  return (
   <IdLayout active="companies" profile={profile}>
    <div>
      {loading && <div>
        <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
        </div>}
      {successInfo && <div className="success-box">
          <p>Company <strong>{successInfo.name}</strong> was created. The owner ({successInfo.email}) has been emailed their login details.</p>
          <p>Temporary password (in case the email does not arrive): <strong>{successInfo.password}</strong></p>
          <button onClick={()=>setSuccessInfo(null)}>Dismiss</button>
      </div>}
      {userSuccessInfo && <div className="success-box">
          <p><strong>{userSuccessInfo.name}</strong> was added to <strong>{userSuccessInfo.companyName}</strong> ({userSuccessInfo.email}) and has been emailed their login details.</p>
          {userSuccessInfo.password && <p>Temporary password (in case the email does not arrive): <strong>{userSuccessInfo.password}</strong></p>}
          <button onClick={()=>setUserSuccessInfo(null)}>Dismiss</button>
      </div>}
      {view=='list' && <div>
        <button className='greenbutton no-print' onClick={onNewCompany}>New Company</button>
        <div>
            <IdInput type="text" placeholder='Search Company Name/Email' value={search} onChange={(e) =>onSearch(e.target.value) }/>
        </div>
        <table className='specialtable'>
        <tr>
            <th>Company</th>
            <th>Owner</th>
            <th>Contact Email</th>
            <th>Phone</th>
            <th>Plan</th>
            <th>Wallet Balance</th>
            <th>Status</th>
            <th>Date Created</th>
            <th>Actions</th>
        </tr>
        {fcompanies?.map((c, idx) =>{return (
         <tr key={idx}>
            <td>{c.name}</td>
            <td>{c.adminName} <br/> <small>{c.adminEmail}</small></td>
            <td>{c.email}</td>
            <td>{c.phone}</td>
            <td>{getPlanName(c.currentPlanId)}</td>
            <td>{c.unitBalance}</td>
            <td>{c.status}</td>
            <td>{Constants.formatDate(c.createDate) }</td>
            <td>
                <button onClick={()=>onToggleStatus(c)}>{c.status=='enable'? 'Disable' :'Enable'}</button>
                <button onClick={()=>onAddUser(c)}>Add User</button>
            </td>
         </tr>
        )})}
        </table>
        <div style={{fontSize:15, color:'red', textAlign:'center', padding:15, fontWeight:'bold'}}>{err}</div>
      </div>}
      {view=='new' && <div>
        <div style={{display:'flex'}}>
            <div style={{textAlign:'right'}}><button onClick={onCancel}>Close</button></div>
            <div style={{width:500, maxWidth:'80%', margin:'auto'}}>
                <h1>New Company Details</h1>
                <form onSubmit={onSaveCompany}>
                    <IdInput label="Company Name" value={newCompany.name} onChange={(e)=>setNewCompany({...newCompany,name: e.target.value})} required />
                    <IdInput label="Address" value={newCompany.address} onChange={(e)=>setNewCompany({...newCompany,address: e.target.value})} />
                    <div style={{display:'flex'}}>
                        <div style={{marginRight:10}}><IdInput label="Contact Email" type="email" value={newCompany.email} onChange={(e)=>setNewCompany({...newCompany,email: e.target.value})} /></div>
                        <div style={{marginLeft:10}}><IdInput label="Contact Phone" value={newCompany.phone} onChange={(e)=>setNewCompany({...newCompany,phone: e.target.value})} /></div>
                    </div>
                    <IdSelect label="Plan" disabledText="Select Plan" value={newCompany.currentPlanId} onChange={(e)=>setNewCompany({...newCompany,currentPlanId: e.target.value})}
                        items={plans?.map(p=>({value:p.id, text:p.name}))} required />

                    <h3>Company Owner (will receive login details by email)</h3>
                    <div style={{display:'flex'}}>
                        <div style={{marginRight:10}}><IdInput label="Owner First Name" value={newCompany.adminFirstName} onChange={(e)=>setNewCompany({...newCompany,adminFirstName: e.target.value})} required /></div>
                        <div style={{marginLeft:10}}><IdInput label="Owner Last Name" value={newCompany.adminLastName} onChange={(e)=>setNewCompany({...newCompany,adminLastName: e.target.value})} /></div>
                    </div>
                    <IdInput label="Owner Email" type="email" value={newCompany.adminEmail} onChange={(e)=>setNewCompany({...newCompany,adminEmail: e.target.value})} required />
                    <IdInput label="Owner Phone" value={newCompany.adminPhone} onChange={(e)=>setNewCompany({...newCompany,adminPhone: e.target.value})} />

                    {loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16, flexDirection:'column'}}>
                        <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
                        <span style={{ marginLeft:'auto', marginRight:'auto'}}>Loading...</span>
                    </div>}
                    {!loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16}}>
                        <div style={{marginTop:16, marginBottom:16}}>
                            <button className='greenbutton' style={{width:'100%'}}>Save</button>
                        </div>
                    </div>}
                </form>
                <div style={{fontSize:15, color:'red', textAlign:'center', padding:15, fontWeight:'bold'}}>{err}</div>
            </div>
        </div>
      </div>}
      {view=='adduser' && <div>
        <div style={{display:'flex'}}>
            <div style={{textAlign:'right'}}><button onClick={onCancel}>Close</button></div>
            <div style={{width:500, maxWidth:'80%', margin:'auto'}}>
                <h1>Add User to {company.name}</h1>
                <form onSubmit={onSaveUser}>
                    <div style={{display:'flex'}}>
                        <div style={{marginRight:10}}><IdInput label="First Name" value={newUser.firstname} onChange={(e)=>setNewUser({...newUser,firstname: e.target.value})} required /></div>
                        <div style={{marginLeft:10}}><IdInput label="Last Name" value={newUser.lastname} onChange={(e)=>setNewUser({...newUser,lastname: e.target.value})} /></div>
                    </div>
                    <IdInput label="Email" type="email" value={newUser.email} onChange={(e)=>setNewUser({...newUser,email: e.target.value})} required />
                    <IdInput label="Phone" value={newUser.phone} onChange={(e)=>setNewUser({...newUser,phone: e.target.value})} />
                    <IdSelect label="Role" disabledText="Select Role" value={newUser.userType} onChange={(e)=>setNewUser({...newUser,userType: e.target.value})} items={roleOptions} required />
                    <p style={{fontSize:12, color:'#777'}}>Leave password blank to auto-generate one — it will be emailed to the user and shown here once saved.</p>
                    <IdInput label="Password (optional)" type="password" value={newUser.password} onChange={(e)=>setNewUser({...newUser,password: e.target.value})} />

                    {loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16, flexDirection:'column'}}>
                        <img src={LoadingImg} style={{width:300, marginLeft:'auto', marginRight:'auto'}} />
                        <span style={{ marginLeft:'auto', marginRight:'auto'}}>Loading...</span>
                    </div>}
                    {!loading && <div style={{display:'flex', justifyContent:'center', marginBottom:16}}>
                        <div style={{marginTop:16, marginBottom:16}}>
                            <button className='greenbutton' style={{width:'100%'}}>Save</button>
                        </div>
                    </div>}
                </form>
                <div style={{fontSize:15, color:'red', textAlign:'center', padding:15, fontWeight:'bold'}}>{userErr}</div>
            </div>
        </div>
      </div>}
    </div>
    {showStatus &&
    <div className={ "dialog-box open" }>
        <div className="wrapper">
            <h3>You are about to change the status of {company.name} from {company.status=='enable'?'Enable':'Disable'} to {company.status=='enable'?'Disable':'Enable'}</h3>
            {company.status=='enable' && <p style={{color:'red'}}>Disabling this company will remove its live API key. Its demo key remains active.</p>}
            {company.status!='enable' && <p>Enabling this company will generate a new live API key for it.</p>}
            <button onClick={onChangeStatus}>Save Changes</button>
            <button onClick={resetStatus}>Cancel</button>
        </div>
    </div>
    }
   </IdLayout>
  )
}

export default Companies
